import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnChanges } from '@angular/core';
import { SocialLink } from 'app/modules/social/models/social-link.model';
import Bricks from 'bricks.js';

@Component({
  selector: 'app-social-item-list',
  templateUrl: './social-item-list.component.html',
  styleUrls: ['./social-item-list.component.scss'],
})
export class SocialItemListComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() posts: SocialLink[];
  @Input() previewObj: SocialLink;

  @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() onPreview: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAdd: EventEmitter<any> = new EventEmitter<any>();

  bricks: Bricks;

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.initBricks();
  }

  ngOnChanges() {
    this.updateBricks();
  }

  initBricks() {
    const sizes = [
      { columns: 1, gutter: 60 },
      { mq: '1180px', columns: 2, gutter: 30 },
      { mq: '1366px', columns: 2, gutter: 90 },
    ];

    this.bricks = Bricks({
      container: '[masonry-grid]',
      packed: 'data-packed',
      sizes: sizes,
    });

    this.bricks.on('resize', this.updateBricks.bind(this));
    this.updateBricks();
  }

  updateBricks() {
    if (this.bricks) {
      setTimeout(() => {
        this.bricks.resize(true);
        this.bricks.pack().update();
      }, 0);
    }
  }

  togglePlay(el) {
    const video = el.target;
    const icon = video.nextElementSibling;

    if (video.paused) {
      video.play();
      icon.style.opacity = 0;
    } else {
      video.pause();
      icon.style.opacity = 1;
    }

    // set video at start when finished
    video.onended = () => {
      video.currentTime = 0;
      icon.style.opacity = 1;
    };
  }

  scrapeUrl(e) {
    this.onPreview.emit(e);
    this.bricks.pack();
  }

  addItem(e) {
    this.onAdd.emit(e);
    setTimeout(this.updateBricks.bind(this), 500);
  }
}
